import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DebugComponent } from './shared/components/debug/debug.component';
import { UserGuard } from './shared/guards/user.guard';


const routes: Routes = [
	// this is just here as an example
	// {path: 'admin', canLoad: [ SystemAdministratorGuard, ], loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},

	{path: 'test/guard/user', component: DebugComponent, canActivate: [UserGuard]},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
